import Container from "./Container.react"

const content = { Container }
export default content
